var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unsupported)?_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('fresh-vue.AlertUnsupportedBrowser.message'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }